import { Mic, MicOff, PhoneOff } from "lucide-react";
import { MagicalIconButton } from "./MagicalIconButton";
import type { VoiceBridgeStatus } from "@/services/integrations/twilio/VoiceBridgeService";

interface HumanCallBarProps {
  brandColor: string;
  secondaryColor?: string | null;
  status: VoiceBridgeStatus;
  muted: boolean;
  destinationLabel?: string | null;
  onToggleMute: () => void;
  onHangup: () => void;
}

function getStatusLabel(status: VoiceBridgeStatus, destinationLabel?: string | null): string {
  if (!destinationLabel) return STATUS_LABEL[status];
  if (status === "connecting") return `Calling ${destinationLabel}…`;
  if (status === "in-call") return `Connected with ${destinationLabel}`;
  return STATUS_LABEL[status];
}

const STATUS_LABEL: Record<VoiceBridgeStatus, string> = {
  idle: "",
  "requesting-token": "Connecting…",
  connecting: "Connecting…",
  "in-call": "Connected with a human",
  ended: "Call ended",
  failed: "Couldn't connect",
};

export const HumanCallBar = ({
  brandColor,
  secondaryColor,
  status,
  muted,
  destinationLabel,
  onToggleMute,
  onHangup,
}: HumanCallBarProps) => {
  const isLive = status === "in-call";

  return (
    <div className="mt-4 flex w-full flex-col items-center gap-3 px-3">
      <span className="text-[13px] font-medium text-[#64748B]">{getStatusLabel(status, destinationLabel)}</span>
      <div className="flex flex-row items-end justify-center gap-8 sm:gap-10">
        <MagicalIconButton
          onClick={onToggleMute}
          brandColor={brandColor}
          secondaryColor={secondaryColor}
          size={36}
          ariaLabel={muted ? "Unmute microphone" : "Mute microphone"}
          label={muted ? "Unmute" : "Mute"}
          activeState={muted ? "danger" : null}
          disabled={!isLive}
        >
          {muted ? <MicOff size={16} strokeWidth={2} /> : <Mic size={16} strokeWidth={2} />}
        </MagicalIconButton>

        <MagicalIconButton
          onClick={onHangup}
          brandColor={brandColor}
          size={44}
          ariaLabel="End call"
          label="Hang up"
          activeState="danger"
        >
          <PhoneOff size={20} strokeWidth={2} />
        </MagicalIconButton>
      </div>
    </div>
  );
};

export default HumanCallBar;
